var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import classnames from 'classnames';
import { tokens } from '@servicetitan/tokens/core';
import { Button, Headline } from '../';
import { Overlay } from '../../internal/Overlay';
import { useFocusTrap } from '../../hooks';
export const Drawer = (_a) => {
    var { animate = true, children, className, contentClassName, footerClassName, footer, footerAlign = 'right', header, onClose, open, portal = true, backdrop, width = 's', focusTrapOptions } = _a, rest = __rest(_a, ["animate", "children", "className", "contentClassName", "footerClassName", "footer", "footerAlign", "header", "onClose", "open", "portal", "backdrop", "width", "focusTrapOptions"]);
    // Focus trapping
    const drawerRef = useFocusTrap(Object.assign({ autoFocusContainer: true, disabled: !open }, focusTrapOptions));
    const DrawerClasses = classnames('Drawer', className, {
        'Drawer--open': open,
        'Drawer--portal': portal || backdrop,
        'Drawer--close': !open,
        [`Drawer--w-${width}`]: width,
    });
    const DrawerContentClassNames = classnames('Drawer__content', contentClassName);
    const DrawerFooterClassNames = classnames('Drawer__footer', footerClassName, {
        'justify-content-start': footerAlign === 'left',
        'justify-content-center': footerAlign === 'center',
        'justify-content-end': footerAlign === 'right',
        'justify-content-between': footerAlign === 'space-between',
    });
    const durationSlow = parseInt(tokens.durationSlow, 10) / 1000; // '300ms' -> 0.3
    const framerAnimation = {
        initial: { opacity: 0, x: '100%' },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: '100%' },
        transition: { type: 'easeInOut', duration: durationSlow },
    };
    const DrawerEl = animate ? motion.div : 'div';
    const DrawerProps = Object.assign(Object.assign({ className: DrawerClasses, ref: drawerRef }, (animate && framerAnimation)), rest);
    return (React.createElement(Overlay, { animate: animate, portal: portal, backdrop: backdrop, onClose: onClose, open: open },
        React.createElement(AnimatePresence, null, open && (React.createElement(DrawerEl, Object.assign({ "data-anvil-component": "Drawer" }, DrawerProps),
            header && (React.createElement("div", { className: "Drawer__header" },
                React.createElement(Headline, { className: "Drawer__header-title" }, header),
                onClose && (React.createElement(Button, { "aria-label": "close drawer", fill: "subtle", className: "Drawer__header-close", iconName: "clear", size: "xsmall", onClick: onClose })))),
            React.createElement("div", { className: DrawerContentClassNames }, children),
            footer && (React.createElement("div", { className: DrawerFooterClassNames }, footer)))))));
};
//# sourceMappingURL=Drawer.js.map